const actionColumn = { id: 'actions', labelKey: '', align: 'right' };

const columnsByList = {
  andamento: [
    { id: 'post_sale', labelKey: 'POST_SALE.TABLE.POST_SALE' },
    { id: 'address', labelKey: 'POST_SALE.TABLE.ADDRESS' },
    { id: 'status', labelKey: 'POST_SALE.TABLE.STATUS' },
    { id: 'status_deadline', labelKey: 'POST_SALE.TABLE.STATUS_DEADLINE' },
    { id: 'entry_date', labelKey: 'POST_SALE.TABLE.ENTRY_DATE' },
    { id: 'payment', labelKey: 'POST_SALE.TABLE.PAYMENT' },
    { id: 'laudemium', labelKey: 'POST_SALE.TABLE.LAUDEMIUM' },
    { id: 'manager', labelKey: 'POST_SALE.TABLE.MANAGER' },
    actionColumn,
  ],
  revisoes: [
    { id: 'post_sale', labelKey: 'POST_SALE.TABLE.POST_SALE' },
    { id: 'address', labelKey: 'POST_SALE.TABLE.ADDRESS' },
    { id: 'signature_date', labelKey: 'POST_SALE.TABLE.SIGNATURE_DATE' },
    { id: 'request_date', labelKey: 'POST_SALE.TABLE.REQUEST_DATE' },
    { id: 'elapsed_days', labelKey: 'POST_SALE.TABLE.ELAPSED_DAYS' },
    { id: 'corrections', labelKey: 'POST_SALE.TABLE.CORRECTIONS' },
    { id: 'laudemium', labelKey: 'POST_SALE.TABLE.LAUDEMIUM' },
    { id: 'manager', labelKey: 'POST_SALE.TABLE.MANAGER' },
    actionColumn,
  ],
  finalizadas: [
    { id: 'post_sale', labelKey: 'POST_SALE.TABLE.POST_SALE' },
    { id: 'address', labelKey: 'POST_SALE.TABLE.ADDRESS' },
    { id: 'completion_date', labelKey: 'POST_SALE.TABLE.COMPLETION_DATE' },
    { id: 'payment', labelKey: 'POST_SALE.TABLE.PAYMENT' },
    { id: 'laudemium', labelKey: 'POST_SALE.TABLE.LAUDEMIUM' },
    { id: 'manager', labelKey: 'POST_SALE.TABLE.MANAGER' },
    actionColumn,
  ],
  cancelados: [
    { id: 'post_sale', labelKey: 'POST_SALE.TABLE.POST_SALE' },
    { id: 'address', labelKey: 'POST_SALE.TABLE.ADDRESS' },
    { id: 'cancellation_date', labelKey: 'POST_SALE.TABLE.CANCELLATION_DATE' },
    { id: 'payment', labelKey: 'POST_SALE.TABLE.PAYMENT' },
    { id: 'laudemium', labelKey: 'POST_SALE.TABLE.LAUDEMIUM' },
    { id: 'manager', labelKey: 'POST_SALE.TABLE.MANAGER' },
    actionColumn,
  ],
};

export const columnsForPostSaleList = list =>
  columnsByList[list] || columnsByList.andamento;
